import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValueSet, LocalService, PageKey, RelationShipRole, Wrappers10 } from '../../../service/local.service';

@Component({
  selector: 'app-paid-by-company',
  templateUrl: './paid-by-company.component.html',
  styleUrls: ['./paid-by-company.component.scss']
})
export class PaidByCompanyComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["prepaid"]; prepaidReasons: KeyValueSet[];
  wrapper: Wrappers10; maxBodyHeight = 0;
  ctryCode: string = ''; userId: string = ''; businessId: string = ''; interactionType: InteractionType;
  RelationShipRole = RelationShipRole;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, public billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PrepaidDetailReason).subscribe(result => {
      this.prepaidReasons = result;
    });
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.User)
        this.businessId = this.userId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.PaidByCompanyBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.PaidByCompanyServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.None);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.billingManagementService.getPaidByCompanyDetails(this.businessId, this.interactionType, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
        this.wrapper = result;
      });
    }
  }
}
